// extracted by mini-css-extract-plugin
module.exports = {"container":"ManagementExp_container__3z1tv","coverImg":"ManagementExp_coverImg__3c6yb","title":"ManagementExp_title__3mlT-","content":"ManagementExp_content__kJBiC"};